export default "__VITE_ASSET__BkfkoN_t__"